var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5004 28.8484C22.4257 28.8484 28.8504 22.4237 28.8504 14.4984C28.8504 6.57315 22.4257 0.148437 14.5004 0.148437C6.5751 0.148437 0.150391 6.57315 0.150391 14.4984C0.150391 22.4237 6.57511 28.8484 14.5004 28.8484ZM21.15 13.2301L15.7688 7.84881C15.0683 7.14831 13.9325 7.14831 13.232 7.84881C12.5315 8.54932 12.5315 9.68506 13.232 10.3856L15.5511 12.7047L9.11914 12.7047C8.12848 12.7047 7.32539 13.5078 7.32539 14.4984C7.32539 15.4891 8.12848 16.2922 9.11914 16.2922L15.5511 16.2922L13.232 18.6113C12.5315 19.3118 12.5315 20.4476 13.232 21.1481C13.9325 21.8486 15.0683 21.8486 15.7688 21.1481L21.15 15.7668C21.8505 15.0663 21.8505 13.9306 21.15 13.2301Z",
    fill: "#0076A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightMoveIcon);
export default __webpack_public_path__ + "static/media/right-move-Icon.2bb9334a6b731818e66fe7636e7b186c.svg";
export { ForwardRef as ReactComponent };